/** Stripe publishable key (same account as EAE program / REPass checkout). */
export const STRIPE_PUBLISHABLE_KEY =
  'pk_live_51P128qP6BucL4HOzvB46mZ4G6n5nyygpBo3DmJPSEPo5NSdeTsvrFxVO4PQUF3vO6WhWd1nhEgYcrQ63cFZSpMo500NFO4Pe0i'

const BACKEND_ORIGIN = 'https://web-backend.eae.international'

/** Production student portal (hash-router). Override via VUE_APP_DSA_FRONT_URL at build time. */
export const DSA_FRONT_ORIGIN = process.env.VUE_APP_DSA_FRONT_URL || 'https://my.dsaexam.com'

/** Base URL for Stripe embed PHP endpoints. Dev uses vue proxy; production uses backend host. */
export function getStripeApiBase() {
  if (process.env.NODE_ENV === 'development') {
    return ''
  }
  return BACKEND_ORIGIN
}

export function getDsaPassEmbedPayUrl() {
  return `${getStripeApiBase()}/Stripe/DsaPassEmbedPay.php`
}

/** Ensure Stripe.js is available (index.html loads it async). */
export function ensureStripeJs() {
  if (typeof window !== 'undefined' && window.Stripe) {
    return Promise.resolve(window.Stripe)
  }
  return new Promise((resolve, reject) => {
    let tries = 0
    const waitReady = () => {
      if (window.Stripe) {
        resolve(window.Stripe)
        return
      }
      if (++tries > 80) {
        tries = 0
        const failed = document.querySelector('script[src*="js.stripe.com/v3"]')
        if (failed && failed.parentNode) failed.parentNode.removeChild(failed)
        appendStripeScript(true)
        return
      }
      setTimeout(waitReady, 100)
    }
    const appendStripeScript = (cacheBust = false) => {
      const s = document.createElement('script')
      s.src = `https://js.stripe.com/v3/${cacheBust ? `?retry=${Date.now()}` : ''}`
      s.async = true
      s.onload = () => waitReady()
      s.onerror = () => reject(new Error('Stripe.js failed to load'))
      document.head.appendChild(s)
    }
    if (document.querySelector('script[src*="js.stripe.com/v3"]')) waitReady()
    else appendStripeScript()
  })
}

/** Stripe embedded checkout return URL after server callback (hash-router). */
export function getDsaPassPaymentReturnUrl() {
  const origin = process.env.NODE_ENV === 'development'
    ? `${window.location.origin}${window.location.pathname || '/'}`
    : DSA_FRONT_ORIGIN
  const base = origin.replace(/\/$/, '')
  return `${base}/#/student/dashboard?paid=1`
}

export function stripeCurrencyCode(currency) {
  const c = (currency || 'USD').toUpperCase()
  if (c === 'USD') return 'usd'
  if (c === 'SGD') return 'sgd'
  if (c === 'GBP') return 'gbp'
  if (c === 'CNY') return 'cny'
  return c.toLowerCase()
}
